import { SxProps } from "@mui/material";

const styles: { [key: string]: SxProps } = {
  workbench: {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", md: "300px 1fr" },
    gap: 2,
    mt: 2,
  },
  rail: {
    alignSelf: "start",
    position: { md: "sticky" },
    top: { md: 16 },
  },
  railGroupHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    px: 2,
    pt: 1,
  },
  publishBar: {
    p: 2,
    mt: 2,
  },
  publishBarTop: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 2,
  },
  publishBarBody: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 2,
    mt: 2,
  },
  lifecycle: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 3,
    flexGrow: 1,
  },
  publishBarMeta: {
    display: "flex",
    flexDirection: "column",
  },
  lifecycleTrack: {
    display: "flex",
    alignItems: "center",
    listStyle: "none",
    m: 0,
    p: 0,
  },
  lifecycleNode: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },
  lifecycleLine: {
    width: 40,
    height: 2,
    mx: 1.25,
    backgroundColor: "grey.300",
  },
  lifecycleLineReached: {
    width: 40,
    height: 2,
    mx: 1.25,
    backgroundColor: "primary.main",
  },
  lifecycleOffRamp: {
    width: 28,
    mx: 1.25,
    borderTop: "2px dashed",
    borderColor: "grey.300",
  },
  lifecycleIcon: {
    width: 26,
    height: 26,
    flexShrink: 0,
    borderRadius: "50%",
    border: "2px solid",
    borderColor: "grey.300",
    backgroundColor: "common.white",
    color: "common.white",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
    fontSize: 16,
  },
  lifecycleIconReached: {
    backgroundColor: "primary.main",
    borderColor: "primary.main",
  },
  lifecycleIconDraft: {
    backgroundColor: "grey.700",
    borderColor: "grey.700",
    boxShadow: "0 0 0 4px rgba(97, 97, 97, 0.16)",
  },
  lifecycleIconReview: {
    backgroundColor: "warning.main",
    borderColor: "warning.main",
    boxShadow: "0 0 0 4px rgba(237, 108, 2, 0.16)",
  },
  lifecycleIconActive: {
    backgroundColor: "success.main",
    borderColor: "success.main",
    boxShadow: "0 0 0 4px rgba(46, 125, 50, 0.16)",
  },
  lifecycleIconArchived: {
    backgroundColor: "error.dark",
    borderColor: "error.dark",
    boxShadow: "0 0 0 4px rgba(176, 0, 32, 0.12)",
  },
  lifecycleLabel: {
    color: "text.secondary",
    whiteSpace: "nowrap",
  },
  lifecycleLabelReached: {
    color: "text.primary",
    whiteSpace: "nowrap",
  },
  lifecycleLabelCurrent: {
    color: "text.primary",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
  lifecycleLabelDisabled: {
    color: "text.disabled",
    whiteSpace: "nowrap",
  },
  transitions: {
    display: "flex",
    flexWrap: "wrap",
    gap: 1,
  },
  paneHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    mb: 2,
  },
  sectionActions: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1,
    mb: 1,
  },
  notesAccordion: {
    mt: 1,
  },
  actionBar: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    mt: 3,
  },
  requirementCircle: {
    width: 24,
    height: 24,
    fontSize: 12,
    backgroundColor: "#eee",
    color: "#000",
  },
};

export default styles;
